import { CSSProperties } from 'react';

import LottieView from 'lottie-react-native';
import { ViewStyle } from 'react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';

// Only use common props values here. Don't use specific platform styles
const commonStyles: ViewStyle | CSSProperties = {
  left: -35,
  bottom: -50,
  height: 170,
  width: 170,
  zIndex: -1,
  position: 'absolute',
};

export const ConfettiAnimation = ({
  animationRef,
}: {
  animationRef: React.RefObject<LottieView>;
}) => {
  const uri = useStaticLottieUri(StaticImages.ConfettiRewardsButton);

  if (!uri) {
    return null;
  }

  return (
    <LottieView
      ref={animationRef}
      key={uri}
      source={{ uri }}
      loop={false}
      resizeMode="cover"
      autoPlay={false}
      style={commonStyles as ViewStyle}
      webStyle={commonStyles as CSSProperties}
    />
  );
};
